/**
 * Winwin — lot detail: authenticated state, bid gate, place bid, watchlist.
 */
(function () {
  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Winwin never shows Selloff "pre-bid" jargon — that is just online bidding. */
  function sanitizeBidderError(text) {
    var raw = String(text || '').trim();
    if (!raw) return '';
    if (/pre[-\s]?bids?/i.test(raw)) return 'Bidding is closed for this lot.';
    return raw.replace(/\bpre[-\s]?bids?\b/gi, 'bids');
  }

  function currencyOf(lot) {
    var cur = (lot.currency && (lot.currency.symbol || lot.currency)) || 'CHF';
    if (typeof cur === 'object') cur = cur.symbol || 'CHF';
    return cur;
  }

  function money(lot, amount) {
    if (amount == null || amount === '' || amount === false) return '—';
    var cur = currencyOf(lot);
    var raw = String(amount).trim();
    if (/^(CHF|EUR|USD|GBP|£|€)\b/i.test(raw)) return raw;
    return cur + ' ' + raw;
  }

  function estimateLabel(lot) {
    var cur = currencyOf(lot);
    if (lot.printed_estimate) {
      var printed = String(lot.printed_estimate).trim();
      if (/^(CHF|EUR|USD|GBP|£|€)\b/i.test(printed)) return printed;
      return cur + ' ' + printed;
    }
    if (lot.estimate != null && lot.estimate !== '') {
      return cur + ' ' + lot.estimate;
    }
    if (lot.low_estimate != null || lot.high_estimate != null) {
      return cur + ' ' + (lot.low_estimate || '—') + ' – ' + (lot.high_estimate || '—');
    }
    return '—';
  }

  /** Official auction open: sale window from_date → to_date (Europe/Zurich). */
  function parseEnglishDateStart(raw) {
    var m = String(raw || '').match(/(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{4})/i);
    if (!m) return '';
    var months = { jan: '01', feb: '02', mar: '03', apr: '04', may: '05', jun: '06', jul: '07', aug: '08', sep: '09', oct: '10', nov: '11', dec: '12' };
    var mo = months[String(m[2]).slice(0, 3).toLowerCase()];
    if (!mo) return '';
    return m[3] + '-' + mo + '-' + String(m[1]).padStart(2, '0');
  }

  function auctionOpenYmd(lot) {
    if (lot && lot.auction && lot.auction.from_date) {
      var from = String(lot.auction.from_date).slice(0, 10);
      if (/^\d{4}-\d{2}-\d{2}$/.test(from)) return from;
    }
    if (lot && lot.auction && lot.auction.date) {
      var parsed = parseEnglishDateStart(lot.auction.date);
      if (parsed) return parsed;
    }
    if (lot && lot.auction_date_utc) {
      return String(lot.auction_date_utc).slice(0, 10);
    }
    return '';
  }

  function auctionCloseYmd(lot) {
    if (lot && lot.auction && lot.auction.to_date) {
      var to = String(lot.auction.to_date).slice(0, 10);
      if (/^\d{4}-\d{2}-\d{2}$/.test(to)) return to;
    }
    return '';
  }

  function ymdToMsZurich(ymd, endOfDay) {
    var m = String(ymd || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    var y = Number(m[1]);
    var mo = Number(m[2]);
    var d = Number(m[3]);
    var target = m[1] + '-' + m[2] + '-' + m[3];
    var utcGuess = Date.UTC(y, mo - 1, d, endOfDay ? 22 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0);
    for (var i = 0; i < 48; i++) {
      var ts = utcGuess + (endOfDay ? -i : -i) * 3600000;
      if (endOfDay) ts = utcGuess - i * 3600000;
      var ymdOut = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Zurich',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date(ts));
      var hm = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Zurich',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(new Date(ts));
      if (endOfDay) {
        if (ymdOut === target && (hm === '23:59' || hm === '23:58')) return ts;
      } else if (ymdOut === target && (hm === '00:00' || hm === '24:00')) {
        return ts;
      }
    }
    return endOfDay
      ? Date.UTC(y, mo - 1, d, 21, 59, 59)
      : Date.UTC(y, mo - 1, d, -1, 0, 0);
  }

  function auctionOpensAtMs(lot) {
    var ymd = auctionOpenYmd(lot);
    return ymd ? ymdToMsZurich(ymd, false) : null;
  }

  function auctionClosesAtMs(lot) {
    var ymd = auctionCloseYmd(lot);
    return ymd ? ymdToMsZurich(ymd, true) : null;
  }

  function biddingEnded(lot) {
    var closesAt = auctionClosesAtMs(lot);
    if (closesAt != null) return Date.now() > closesAt;
    var ends = lot && lot.bidding_ends_utc;
    if (!ends) return false;
    var t = Date.parse(String(ends).replace(' ', 'T') + 'Z');
    if (isNaN(t)) return false;
    return Date.now() > t;
  }

  function formatOpenDate(lot) {
    var from = auctionOpenYmd(lot);
    var m = String(from).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) {
      if (lot && lot.auction && lot.auction.date) return String(lot.auction.date);
      return '';
    }
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return parseInt(m[3], 10) + ' ' + (months[parseInt(m[2], 10) - 1] || m[2]) + ' ' + m[1];
  }

  function bidIncrementFor(amount) {
    var a = Number(amount) || 0;
    if (a < 50) return 5;
    if (a < 200) return 10;
    if (a < 500) return 20;
    if (a < 1000) return 50;
    if (a < 2000) return 100;
    if (a < 5000) return 200;
    if (a < 10000) return 500;
    return 1000;
  }

  function suggestedBidAmount(lot) {
    var current = Number(lot && lot.current_bid);
    if (!isFinite(current) || current <= 0) current = 0;
    var start = Number(lot && (lot.price != null ? lot.price : lot.estimate));
    if (!isFinite(start) || start < 0) start = 0;
    if (current > 0) return current + bidIncrementFor(current);
    if (start > 0) return start;
    return bidIncrementFor(0);
  }

  function imagesOf(lot) {
    var images = lot.images || [];
    if (!images.length && lot.image) images = [lot.image];
    return images.map(function (img) {
      return {
        src: img.medium || img.file || img.thumbnail || '',
        thumb: img.thumbnail || img.medium || img.file || '',
        alt: lot.name || ''
      };
    }).filter(function (i) { return i.src; });
  }

  function statusLabel(lot) {
    if (biddingEnded(lot)) {
      if (lot && (lot.is_winning_bidder == 1 || lot.is_winning_bidder === true ||
          lot.is_highest_bidder == 1 || lot.is_highest_bidder === true)) {
        return 'You won this lot';
      }
      return 'Bidding closed';
    }
    var opensAt = auctionOpensAtMs(lot);
    if (opensAt != null && Date.now() < opensAt) {
      return 'Opens ' + formatOpenDate(lot);
    }
    // Sale window (from_date → to_date) is authoritative — same as auctions page.
    // Selloff's availability flag can lag after date edits; sale window is authoritative.
    if (opensAt != null || auctionCloseYmd(lot)) return 'Open for bidding';
    if (lot.is_available_for_bidding == 1 || lot.is_available_for_bidding === true) return 'Open for bidding';
    if (lot.is_available_for_offer_unsold == 1 || lot.is_available_for_offer_unsold === true) return 'Open for offers';
    return 'Bidding not yet open';
  }

  function auctionName(lot) {
    if (!lot.auction) return '';
    if (typeof lot.auction === 'string') return lot.auction;
    return lot.auction.name || lot.auction.translated_name || '';
  }

  function bidTypeFor(lot) {
    var t = lot.type || '';
    if (t === 'offer' || lot.is_available_for_offer_unsold == 1 || lot.is_available_for_offer_unsold === true) {
      if (!(lot.is_available_for_bidding == 1 || lot.is_available_for_bidding === true)) return 5;
    }
    return 0;
  }

  function selloffFlagsOpen(lot) {
    return lot.is_available_for_bidding == 1 || lot.is_available_for_bidding === true ||
      lot.is_available_for_offer_unsold == 1 || lot.is_available_for_offer_unsold === true;
  }

  /** True when Zurich "now" is inside auction from_date → to_date. */
  function withinSaleWindow(lot) {
    if (biddingEnded(lot)) return false;
    var opensAt = auctionOpensAtMs(lot);
    if (opensAt != null && Date.now() < opensAt) return false;
    if (opensAt != null || auctionCloseYmd(lot)) return true;
    return false;
  }

  function biddingOpen(lot) {
    if (biddingEnded(lot)) return false;
    var opensAt = auctionOpensAtMs(lot);
    if (opensAt != null && Date.now() < opensAt) return false;
    // Prefer auction sale dates (what you edit on the auction). Fall back to
    // Selloff lot flags only when dates are missing from the payload.
    if (withinSaleWindow(lot)) return true;
    return selloffFlagsOpen(lot);
  }

  function scheduleLabel(lot) {
    var auctionDate = lot.auction && (lot.auction.date || '');
    if (!auctionDate && lot.auction && lot.auction.from_date) {
      auctionDate = formatOpenDate(lot);
    }
    var opensAt = auctionOpensAtMs(lot);
    if (opensAt != null && Date.now() < opensAt) {
      return 'Opens ' + (formatOpenDate(lot) || auctionDate || 'soon');
    }
    // Prefer auction-level dates (what you edit on the sale). Session bidding close
    // can lag if the auction session was not updated in Selloff.
    if (auctionDate) return auctionDate;
    if (lot.bidding_ends || lot.bidding_ends_utc) {
      return 'Closes ' + (lot.bidding_ends || lot.bidding_ends_utc);
    }
    if (lot.auction_date) return lot.auction_date;
    return 'See auction schedule';
  }

  function formatWeekdayTime(ms) {
    if (ms == null || isNaN(ms)) return '';
    try {
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Zurich',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(new Date(ms));
    } catch (e) {
      return '';
    }
  }

  function scheduleHeaderLabel(lot) {
    if (biddingEnded(lot)) return 'Bidding closed';
    var opensAt = auctionOpensAtMs(lot);
    if (opensAt != null && Date.now() < opensAt) {
      var openLabel = formatWeekdayTime(opensAt) || formatOpenDate(lot);
      return openLabel ? ('Bidding opens: ' + openLabel) : 'Bidding opens soon';
    }
    var closesAt = auctionClosesAtMs(lot);
    if (closesAt != null) {
      var closeLabel = formatWeekdayTime(closesAt);
      return closeLabel ? ('Bidding closes: ' + closeLabel) : 'Bidding closes soon';
    }
    if (lot.bidding_ends || lot.bidding_ends_utc) {
      return 'Bidding closes: ' + (lot.bidding_ends || lot.bidding_ends_utc);
    }
    return statusLabel(lot);
  }

  function saleProgressPct(lot) {
    var opensAt = auctionOpensAtMs(lot);
    var closesAt = auctionClosesAtMs(lot);
    if (opensAt == null || closesAt == null || closesAt <= opensAt) return null;
    var now = Date.now();
    if (now <= opensAt) return 0;
    if (now >= closesAt) return 100;
    return Math.max(0, Math.min(100, ((now - opensAt) / (closesAt - opensAt)) * 100));
  }

  function pad2(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function updateScheduleUi(root, lot) {
    setText(root, '[data-lot-schedule-label]', scheduleHeaderLabel(lot));

    var opensAt = auctionOpensAtMs(lot);
    var closesAt = auctionClosesAtMs(lot);
    var now = Date.now();
    var target = null;
    if (opensAt != null && now < opensAt) target = opensAt;
    else if (closesAt != null && now < closesAt) target = closesAt;

    var countdown = root.querySelector('[data-lot-countdown]');
    if (countdown) {
      if (target == null) {
        countdown.hidden = true;
      } else {
        countdown.hidden = false;
        var diff = Math.max(0, target - now);
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        setText(root, '[data-cd-days]', pad2(days));
        setText(root, '[data-cd-hours]', pad2(hours));
        setText(root, '[data-cd-mins]', pad2(mins));
        setText(root, '[data-cd-secs]', pad2(secs));
      }
    }

    var progressWrap = root.querySelector('[data-lot-progress]');
    var progressBar = root.querySelector('[data-lot-progress-bar]');
    var pct = saleProgressPct(lot);
    var showProgress = pct != null && opensAt != null && now >= opensAt && !biddingEnded(lot);
    if (progressWrap) progressWrap.hidden = !showProgress;
    if (progressBar && showProgress) progressBar.style.width = pct.toFixed(2) + '%';

    paintLotScheduleDates(root, lot);
  }

  function formatClock(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/^(\d{1,2}):(\d{2})/);
    if (!m) return s;
    return String(parseInt(m[1], 10)).padStart(2, '0') + ':' + m[2];
  }

  function formatShortDateLabel(raw) {
    if (!raw) return '';
    var m = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return String(raw);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return parseInt(m[3], 10) + ' ' + (months[parseInt(m[2], 10) - 1] || m[2]) + ' ' + m[1];
  }

  function formatScheduleSlot(slot) {
    if (!slot || typeof slot !== 'object') return '';
    var startDate = slot.start_date_formatted || formatShortDateLabel(slot.start_date) || '';
    var endDate = slot.end_date_formatted || formatShortDateLabel(slot.end_date) || '';
    var startTime = formatClock(slot.start_time);
    var endTime = formatClock(slot.end_time);
    var sameDay = startDate && endDate && startDate === endDate;

    if (sameDay) {
      if (startTime && endTime && startTime !== endTime) {
        return startDate + ', ' + startTime + ' – ' + endTime;
      }
      if (endTime && endTime !== '00:00') return startDate + ', until ' + endTime;
      if (startTime && startTime !== '00:00') return startDate + ', from ' + startTime;
      return startDate;
    }

    var startPart = startDate + (startTime && startTime !== '00:00' ? (', ' + startTime) : '');
    var endPart = endDate + (endTime && endTime !== '00:00' ? (', ' + endTime) : '');
    if (startPart && endPart) return startPart + ' – ' + endPart;
    return startPart || endPart || '';
  }

  function lotScheduleSlots(lot, key) {
    var list = lot && lot[key];
    if (!Array.isArray(list) || !list.length) {
      var dates = lot && lot.auction && lot.auction.auction_dates;
      if (dates && typeof dates === 'object') list = dates[key];
    }
    if (!Array.isArray(list)) return [];
    return list.map(formatScheduleSlot).filter(Boolean);
  }

  function paintLotScheduleDates(root, lot) {
    var viewing = lotScheduleSlots(lot, 'viewing');
    var pickup = lotScheduleSlots(lot, 'pickup');
    var wrap = root.querySelector('[data-lot-schedule-dates]');
    var viewingRow = root.querySelector('[data-lot-viewing-row]');
    var pickupRow = root.querySelector('[data-lot-pickup-row]');
    var viewingEl = root.querySelector('[data-lot-viewing]');
    var pickupEl = root.querySelector('[data-lot-pickup]');
    if (viewingRow) viewingRow.hidden = viewing.length === 0;
    if (pickupRow) pickupRow.hidden = pickup.length === 0;
    if (viewingEl) viewingEl.textContent = viewing.length ? viewing.join('\n') : '—';
    if (pickupEl) pickupEl.textContent = pickup.length ? pickup.join('\n') : '—';
    if (wrap) wrap.hidden = viewing.length === 0 && pickup.length === 0;
  }

  function relativeTime(iso) {
    var t = Date.parse(iso || '');
    if (isNaN(t)) return '';
    var sec = Math.round((Date.now() - t) / 1000);
    if (sec < 60) return 'just now';
    if (sec < 3600) return Math.floor(sec / 60) + ' min ago';
    if (sec < 86400) return Math.floor(sec / 3600) + ' hours ago';
    var days = Math.floor(sec / 86400);
    return days === 1 ? '1 day ago' : (days + ' days ago');
  }

  function plural(n, one, many) {
    return n === 1 ? one : many;
  }

  /** Parse Selloff amounts that may be numbers or "CHF 50" strings. */
  function parseAmount(val) {
    if (val == null || val === '' || val === false) return NaN;
    if (typeof val === 'number') return val;
    var s = String(val).replace(/,/g, '').replace(/[^\d.-]/g, '');
    if (!s) return NaN;
    return parseFloat(s);
  }

  function hasCurrentBid(lot) {
    var n = parseAmount(lot && lot.current_bid);
    return isFinite(n) && n > 0;
  }

  function bidHistoryRows(lot) {
    var history = Array.isArray(lot && lot.bid_history) ? lot.bid_history.slice() : [];
    history = history.filter(function (row) {
      return row && (row.amount != null && row.amount !== '');
    });
    history.sort(function (a, b) {
      var tb = Date.parse(b.placed_at || '');
      var ta = Date.parse(a.placed_at || '');
      if (isNaN(tb) && isNaN(ta)) return parseAmount(b.amount) - parseAmount(a.amount);
      if (isNaN(tb)) return 1;
      if (isNaN(ta)) return -1;
      return tb - ta;
    });

    var current = parseAmount(lot && lot.current_bid);
    if (isFinite(current) && current > 0) {
      var top = history[0] ? parseAmount(history[0].amount) : NaN;
      if (!history.length || !isFinite(top) || Math.abs(top - current) > 0.001) {
        history.unshift({
          amount: lot.current_bid,
          bidder_label: 'Highest bid',
          placed_at: '',
          currency: currencyOf(lot)
        });
      } else if (history[0] && !history[0].bidder_label) {
        history[0].bidder_label = 'Highest bid';
      }
    }

    // Selloff has bids but our local feed is empty (e.g. after a redeploy).
    var bidsCount = Number(lot && lot.bids_count);
    if ((!isFinite(bidsCount) || bidsCount < 0) && history.length) bidsCount = history.length;
    if (isFinite(bidsCount) && bidsCount > history.length && history.length > 0) {
      var earlier = bidsCount - history.length;
      history.push({
        amount: '',
        bidder_label: earlier + ' earlier ' + plural(earlier, 'bid', 'bids'),
        placed_at: '',
        is_meta: true
      });
    }
    return history;
  }

  function mergeLotActivity(prev, next) {
    if (!next) return prev;
    if (!prev) return next;
    var out = next;
    var prevWatch = Number(prev.watch_count);
    var nextWatch = Number(next.watch_count);
    if (!isFinite(nextWatch) || nextWatch < 0) nextWatch = 0;
    if (!isFinite(prevWatch) || prevWatch < 0) prevWatch = 0;
    // Keep the higher count in-session so a cold/empty disk read does not wipe UI.
    out.watch_count = Math.max(prevWatch, nextWatch);

    var prevHist = Array.isArray(prev.bid_history) ? prev.bid_history : [];
    var nextHist = Array.isArray(next.bid_history) ? next.bid_history : [];
    if (nextHist.length >= prevHist.length) {
      out.bid_history = nextHist;
    } else {
      var seen = {};
      var merged = [];
      function add(row) {
        if (!row) return;
        var key = String(row.amount) + '|' + String(row.placed_at || '') + '|' + String(row.bidder_label || '');
        if (seen[key]) return;
        seen[key] = true;
        merged.push(row);
      }
      nextHist.forEach(add);
      prevHist.forEach(add);
      out.bid_history = merged;
    }

    var prevBids = Number(prev.bids_count);
    var nextBids = Number(next.bids_count);
    if (!isFinite(nextBids) || nextBids < 0) nextBids = 0;
    if (!isFinite(prevBids) || prevBids < 0) prevBids = 0;
    out.bids_count = Math.max(prevBids, nextBids, (out.bid_history || []).length);
    return out;
  }

  function renderActivity(root, lot) {
    var history = bidHistoryRows(lot);
    var bidsCount = Number(lot && lot.bids_count);
    if (!isFinite(bidsCount) || bidsCount < 0) bidsCount = 0;
    var visibleBids = history.filter(function (row) { return !row.is_meta; }).length;
    bidsCount = Math.max(bidsCount, visibleBids);
    var watchCount = Number(lot && lot.watch_count);
    if (!isFinite(watchCount) || watchCount < 0) watchCount = 0;

    var stats = root.querySelector('[data-lot-activity]');
    if (stats) stats.hidden = false;

    var bidsEl = root.querySelector('[data-lot-bids-count]');
    var watchEl = root.querySelector('[data-lot-watch-count]');
    if (bidsEl) bidsEl.textContent = bidsCount + ' ' + plural(bidsCount, 'bid', 'bids');
    if (watchEl) watchEl.textContent = watchCount + ' following';

    var list = root.querySelector('[data-lot-bid-history]');
    var empty = root.querySelector('[data-lot-bid-history-empty]');
    var moreBtn = root.querySelector('[data-lot-bid-history-more]');
    if (!list) return;

    if (!history.length) {
      list.innerHTML = '';
      list.classList.remove('is-collapsed', 'is-expanded');
      if (moreBtn) moreBtn.hidden = true;
      if (empty) {
        empty.hidden = false;
        empty.textContent = bidsCount > 0
          ? (bidsCount + ' ' + plural(bidsCount, 'bid', 'bids') + ' placed — history will appear as new bids come in on this site.')
          : 'No bids yet.';
      }
      return;
    }

    if (empty) empty.hidden = true;
    list.innerHTML = history.map(function (row) {
      if (row.is_meta) {
        return '<li class="lot-bid-history__meta"><span class="lot-bid-history__who">' +
          escapeHtml(row.bidder_label || '') + '</span></li>';
      }
      var who = escapeHtml(row.bidder_label || 'Bidder');
      var whenRaw = relativeTime(row.placed_at);
      var when = whenRaw ? escapeHtml(whenRaw) : '';
      var amount = row.amount === '' || row.amount == null ? '' : escapeHtml(money(lot, row.amount));
      return '<li>' +
        '<div class="lot-bid-history__main">' +
          '<span class="lot-bid-history__who">' + who + '</span>' +
          (when ? '<span class="lot-bid-history__when">' + when + '</span>' : '') +
        '</div>' +
        (amount ? '<span class="lot-bid-history__amount">' + amount + '</span>' : '') +
        '</li>';
    }).join('');

    var realRows = list.querySelectorAll('li:not(.lot-bid-history__meta)');
    var needsCollapse = realRows.length > 7;
    if (moreBtn) {
      moreBtn.hidden = !needsCollapse;
      if (!needsCollapse) {
        list.classList.remove('is-collapsed', 'is-expanded');
        moreBtn.textContent = 'Show more bids';
        moreBtn.setAttribute('aria-expanded', 'false');
      } else if (!list.classList.contains('is-expanded')) {
        list.classList.add('is-collapsed');
        list.classList.remove('is-expanded');
        var hiddenCount = realRows.length - 7;
        moreBtn.textContent = 'Show ' + hiddenCount + ' more ' + plural(hiddenCount, 'bid', 'bids');
        moreBtn.setAttribute('aria-expanded', 'false');
      } else {
        moreBtn.textContent = 'Show fewer bids';
        moreBtn.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function bindBidHistoryMore(root) {
    var moreBtn = root.querySelector('[data-lot-bid-history-more]');
    var list = root.querySelector('[data-lot-bid-history]');
    if (!moreBtn || !list || moreBtn.dataset.bound) return;
    moreBtn.dataset.bound = '1';
    moreBtn.addEventListener('click', function () {
      var expanded = list.classList.toggle('is-expanded');
      list.classList.toggle('is-collapsed', !expanded);
      var total = list.querySelectorAll('li:not(.lot-bid-history__meta)').length;
      if (expanded) {
        moreBtn.textContent = 'Show fewer bids';
        moreBtn.setAttribute('aria-expanded', 'true');
      } else {
        var hiddenCount = Math.max(0, total - 7);
        moreBtn.textContent = 'Show ' + hiddenCount + ' more ' + plural(hiddenCount, 'bid', 'bids');
        moreBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function quickBidAmounts(lot) {
    var base = suggestedBidAmount(lot);
    var amounts = [base];
    var next = base + bidIncrementFor(base);
    amounts.push(next);
    var jump = next;
    for (var i = 0; i < 4; i++) jump += bidIncrementFor(jump);
    amounts.push(jump);
    var uniq = [];
    amounts.forEach(function (n) {
      var v = Math.round(Number(n) * 100) / 100;
      if (!isFinite(v) || v <= 0) return;
      if (uniq.indexOf(v) === -1) uniq.push(v);
    });
    return uniq.slice(0, 3);
  }

  function syncBidInput(root, lot, opts) {
    opts = opts || {};
    var input = root.querySelector('#lot-bid-amount');
    var hint = root.querySelector('[data-lot-bid-hint]');
    var chips = root.querySelector('[data-lot-quick-bids]');
    if (!input) return;
    var suggested = suggestedBidAmount(lot);
    var step = bidIncrementFor(Number(input.value) || suggested);
    input.step = String(step);
    input.min = String(suggested);
    input.placeholder = money(lot, suggested) + ' or up';
    if (!opts.keepValue || input.value === '') {
      input.value = String(suggested);
    }
    if (hint) {
      hint.textContent = 'Minimum ' + money(lot, suggested) +
        ' · increments of CHF ' + bidIncrementFor(Number(input.value) || suggested);
    }
    if (chips) {
      var amounts = quickBidAmounts(lot);
      var current = Number(input.value) || suggested;
      chips.hidden = amounts.length === 0;
      chips.innerHTML = amounts.map(function (amount) {
        var active = Math.abs(amount - current) < 0.001 ? ' is-active' : '';
        return '<button type="button" class="lot-quick-bid' + active + '" data-lot-quick-bid="' +
          amount + '">' + escapeHtml(money(lot, amount)) + '</button>';
      }).join('');
    }
  }

  function bindQuickBids(root, getLot) {
    var form = root.querySelector('[data-lot-bid-form]');
    if (!form || form.dataset.quickBound) return;
    form.dataset.quickBound = '1';
    var input = form.querySelector('#lot-bid-amount');
    var chips = form.querySelector('[data-lot-quick-bids]');

    if (chips) {
      chips.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-lot-quick-bid]');
        if (!btn || !input) return;
        var amount = Number(btn.getAttribute('data-lot-quick-bid'));
        if (!isFinite(amount)) return;
        input.value = String(amount);
        syncBidInput(root, getLot() || {}, { keepValue: true });
      });
    }
    if (input) {
      input.addEventListener('input', function () {
        syncBidInput(root, getLot() || {}, { keepValue: true });
      });
    }
  }

  function renderGallery(root, images) {
    var main = root.querySelector('[data-lot-gallery-main]');
    var thumbs = root.querySelector('[data-lot-gallery-thumbs]');
    if (!main || !thumbs) return;

    if (!images.length) {
      main.innerHTML = '<div class="lot-image-placeholder" aria-hidden="true">No image yet</div>';
      thumbs.innerHTML = '';
      return;
    }

    main.innerHTML = '<img src="' + escapeHtml(images[0].src) + '" alt="' + escapeHtml(images[0].alt) + '" width="960" height="960" loading="eager" decoding="async">';
    thumbs.innerHTML = images.map(function (img, i) {
      return '<button type="button" class="thumb' + (i === 0 ? ' active' : '') + '" data-src="' + escapeHtml(img.src) + '">' +
        '<img src="' + escapeHtml(img.thumb || img.src) + '" alt="" width="240" height="240" loading="lazy" decoding="async">' +
        '</button>';
    }).join('');

    thumbs.querySelectorAll('.thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = main.querySelector('img');
        if (mainImg) mainImg.src = thumb.getAttribute('data-src');
        thumbs.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  function setText(root, sel, text) {
    var el = root.querySelector(sel);
    if (el) el.textContent = text == null || text === '' ? '—' : String(text);
  }

  function setHtml(root, sel, html) {
    var el = root.querySelector(sel);
    if (!el) return;
    el.innerHTML = html || '';
  }

  function setHidden(root, sel, hidden) {
    var el = root.querySelector(sel);
    if (el) el.hidden = !!hidden;
  }

  function fillLot(root, lot) {
    var sale = auctionName(lot);
    var lotLabel = lot.lot_number != null ? ('Lot ' + lot.lot_number) : 'Lot';
    setText(root, '[data-lot-crumb-sale]', sale || 'Auction');
    setText(root, '[data-lot-crumb-lot]', lotLabel);
    setText(root, '[data-lot-meta]', lotLabel + (sale ? ' · ' + sale : ''));
    setText(root, '[data-lot-title]', lot.name || lot.translated_name || lotLabel);
    setText(root, '[data-lot-estimate]', estimateLabel(lot));
    setText(root, '[data-lot-current-bid]', money(lot, lot.current_bid));

    var userMax = lot.user_max_bid;
    var userRow = root.querySelector('[data-lot-user-bid-row]');
    if (userRow) {
      if (userMax != null && userMax !== '' && userMax !== false) {
        userRow.hidden = false;
        setText(root, '[data-lot-user-max]', money(lot, userMax));
      } else {
        userRow.hidden = true;
      }
    }

    setHidden(root, '[data-lot-highest]', !(lot.is_highest_bidder == 1 || lot.is_highest_bidder === true));
    setHidden(root, '[data-lot-winning]', !(lot.is_winning_bidder == 1 || lot.is_winning_bidder === true));
    updateScheduleUi(root, lot);
    renderActivity(root, lot);

    var desc = lot.description || lot.translated_description || lot.description_alt || '';
    var descBlock = root.querySelector('[data-lot-description-block]');
    if (descBlock) {
      if (desc) {
        descBlock.hidden = false;
        setHtml(root, '[data-lot-description]', desc);
      } else {
        descBlock.hidden = true;
      }
    }

    var extras = root.querySelector('[data-lot-extras]');
    if (extras) {
      var rows = [];
      Object.keys(lot).forEach(function (key) {
        if (key.indexOf('addtl_') !== 0) return;
        var val = lot[key];
        if (val == null || val === '') return;
        rows.push('<div class="bid-row"><span class="lbl">' + escapeHtml(key.replace(/^addtl_/, '').replace(/_/g, ' ')) + '</span><span class="small">' + escapeHtml(val) + '</span></div>');
      });
      extras.innerHTML = rows.join('');
      extras.hidden = rows.length === 0;
    }

    var form = root.querySelector('[data-lot-bid-form]');
    if (form) {
      var idlotInput = form.querySelector('[name="idlot"]');
      var typeInput = form.querySelector('[name="type"]');
      if (idlotInput) idlotInput.value = lot.idlot != null ? String(lot.idlot) : '';
      if (typeInput) typeInput.value = String(bidTypeFor(lot));
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.textContent = bidTypeFor(lot) === 5 ? 'Place offer' : 'Place bid';
      syncBidInput(root, lot);
    }

    renderGallery(root, imagesOf(lot));
  }

  function updateLiveFields(root, lot) {
    setText(root, '[data-lot-current-bid]', money(lot, lot.current_bid));

    var userMax = lot.user_max_bid;
    var userRow = root.querySelector('[data-lot-user-bid-row]');
    if (userRow) {
      if (userMax != null && userMax !== '' && userMax !== false) {
        userRow.hidden = false;
        setText(root, '[data-lot-user-max]', money(lot, userMax));
      } else {
        userRow.hidden = true;
      }
    }

    setHidden(root, '[data-lot-highest]', !(lot.is_highest_bidder == 1 || lot.is_highest_bidder === true));
    setHidden(root, '[data-lot-winning]', !(lot.is_winning_bidder == 1 || lot.is_winning_bidder === true));
    updateScheduleUi(root, lot);
    renderActivity(root, lot);

    var form = root.querySelector('[data-lot-bid-form]');
    if (form) {
      var idlotInput = form.querySelector('[name="idlot"]');
      var typeInput = form.querySelector('[name="type"]');
      if (idlotInput && lot.idlot != null) idlotInput.value = String(lot.idlot);
      if (typeInput) typeInput.value = String(bidTypeFor(lot));
      var submit = form.querySelector('[type="submit"]');
      if (submit && !submit.disabled) {
        submit.textContent = bidTypeFor(lot) === 5 ? 'Place offer' : 'Place bid';
      }
      syncBidInput(root, lot, { keepValue: true });
    }
  }

  function conditionsHref(lot) {
    var sources = [];
    if (lot && lot.catalogue) sources.push(lot.catalogue);
    if (lot && lot.catalogues) sources = sources.concat(lot.catalogues);
    if (lot && lot.auction && lot.auction.catalogues) sources = sources.concat(lot.auction.catalogues);
    for (var i = 0; i < sources.length; i++) {
      var pdf = sources[i] && sources[i].pdf_conditions;
      if (!pdf) continue;
      if (typeof pdf === 'string') return pdf;
      var file = pdf.file || pdf.url || pdf.src || '';
      if (file) return file;
    }
    return '';
  }

  function applyConditionsLink(root, lot) {
    var href = conditionsHref(lot);
    if (!href) return;
    root.querySelectorAll('[data-lot-conditions-link]').forEach(function (a) {
      a.href = href;
    });
  }

  function shouldPoll(lot) {
    if (!lot) return false;
    if (biddingOpen(lot)) return true;
    if (lot.bids_is_competitive == 1 || lot.bids_is_competitive === true) return true;
    if (lot.auction && (lot.auction.bids_is_competitive == 1 || lot.auction.bids_is_competitive === true)) return true;
    return false;
  }

  function startLivePoll(root, apiDirect, idcatalogue, lotNumber, state) {
    var timer = null;
    var inFlight = false;

    async function tick() {
      if (document.visibilityState === 'hidden') return;
      if (inFlight) return;
      if (!shouldPoll(state.lot)) {
        stop();
        return;
      }
      inFlight = true;
      try {
        var res = await loadLot(root, apiDirect, idcatalogue, lotNumber);
        if (res.ok && res.data && res.data.lot) {
          var prevLot = state.lot;
          var prevOpen = biddingOpen(state.lot);
          var prevEnded = biddingEnded(state.lot);
          state.lot = mergeLotActivity(prevLot, res.data.lot);
          if (res.data.user) state.user = res.data.user;
          if (window.WinwinPush) {
            window.WinwinPush.onLotUpdate(prevLot, state.lot, {
              ended: biddingEnded(state.lot),
              wasEnded: prevEnded
            });
          }
          updateLiveFields(root, state.lot);
          if (prevOpen !== biddingOpen(state.lot)) {
            paintActions(root, state.lot, state.user);
          } else {
            var watch = root.querySelector('[data-lot-watch]');
            if (watch) {
              var bookmarked = state.lot.is_bookmarked == 1 || state.lot.is_bookmarked === true;
              watch.classList.toggle('is-on', bookmarked);
              if (!watch.disabled) {
                watch.textContent = bookmarked ? 'Remove from watchlist' : 'Add to watchlist';
              }
            }
          }
          if (!shouldPoll(state.lot)) stop();
        }
      } catch (e) {
        /* ignore transient poll errors */
      }
      inFlight = false;
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!shouldPoll(state.lot)) return;
      timer = setInterval(tick, 4000);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && shouldPoll(state.lot)) {
        tick();
        start();
      }
    });

    start();
    return { start: start, stop: stop, tick: tick };
  }

  function paintActions(root, lot, user) {
    var guest = root.querySelector('[data-lot-cta-guest]');
    var pending = root.querySelector('[data-lot-cta-pending]');
    var needId = root.querySelector('[data-lot-cta-id]');
    var closed = root.querySelector('[data-lot-cta-closed]');
    var form = root.querySelector('[data-lot-bid-form]');
    var needConditions = root.querySelector('[data-lot-cta-conditions]');
    var watch = root.querySelector('[data-lot-watch]');

    [guest, pending, needId, closed, form, needConditions].forEach(function (el) {
      if (el) el.hidden = true;
    });

    var authed = !!(user && (user.idcontact || user.email));
    var emailOk = !!(user && user.login_confirmed);
    var idOk = !!(user && user.identification_complete);
    var approved = authed && user.status === 'approved';
    var accepted = !!(user && user.accepted_conditions);
    var open = biddingOpen(lot);
    var accountUrl = root.dataset.accountUrl || '/pages/account-profile';
    var conditionsLink = root.querySelector('[data-lot-conditions-account-link]');
    if (conditionsLink) conditionsLink.href = accountUrl;

    if (!authed) {
      if (guest) guest.hidden = false;
    } else if (!emailOk || !approved) {
      if (pending) pending.hidden = false;
    } else if (!idOk) {
      if (needId) needId.hidden = false;
    } else if (!accepted) {
      if (needConditions) needConditions.hidden = false;
    } else if (!open) {
      if (closed) {
        closed.hidden = false;
        var won = !!(lot && (lot.is_winning_bidder == 1 || lot.is_winning_bidder === true ||
          lot.is_highest_bidder == 1 || lot.is_highest_bidder === true));
        var msg = closed.querySelector('[data-lot-closed-msg]');
        if (msg) {
          msg.textContent = won ? 'You won this lot' : (biddingEnded(lot) ? 'Bidding closed' : statusLabel(lot));
        }
        var links = closed.querySelector('[data-lot-closed-links]');
        if (links) links.hidden = !won;
      }
    } else if (form) {
      form.hidden = false;
    }

    if (watch) {
      watch.hidden = false;
      var bookmarked = lot.is_bookmarked == 1 || lot.is_bookmarked === true;
      watch.classList.toggle('is-on', bookmarked);
      watch.textContent = bookmarked ? 'Remove from watchlist' : 'Add to watchlist';
      watch.disabled = false;
    }
    renderActivity(root, lot);
  }

  async function loadLot(root, apiDirect, idcatalogue, lotNumber) {
    var path = '/lot?idcatalogue=' + encodeURIComponent(idcatalogue) +
      '&lot_number=' + encodeURIComponent(lotNumber) + '&refresh=1';
    if (window.WinwinApi) {
      return window.WinwinApi.request(apiDirect, path);
    }
    var res = await fetch(apiDirect + path, { credentials: 'include', headers: { Accept: 'application/json' } });
    var data = null;
    try { data = await res.json(); } catch (e) { data = null; }
    return { ok: res.ok, status: res.status, data: data };
  }

  async function init(root) {
    var apiDirect = (root.dataset.apiDirect || (window.WinwinApi && window.WinwinApi.DEFAULT_BASE) ||
      'https://api.winwingeneve.ch').replace(/\/$/, '');
    var loginUrl = root.dataset.loginUrl || '/pages/login';
    var idcatalogue = qs('idcatalogue');
    var lotNumber = qs('lot_number');
    var loading = root.querySelector('[data-lot-loading]');
    var error = root.querySelector('[data-lot-error]');
    var content = root.querySelector('[data-lot-content]');

    if (loading) loading.hidden = false;
    if (error) error.hidden = true;
    if (content) content.hidden = true;

    if (!idcatalogue || !lotNumber) {
      if (loading) loading.hidden = true;
      if (error) {
        error.hidden = false;
        error.textContent = 'Missing lot reference. Open a lot from the auction catalogue.';
      }
      return;
    }

    var loginLink = root.querySelector('[data-lot-login-link]');
    if (loginLink) {
      loginLink.href = loginUrl + '?next=' + encodeURIComponent(window.location.pathname + window.location.search);
    }

    var state = { lot: null, user: null };

    try {
      var session = window.WinwinApi
        ? await window.WinwinApi.request(apiDirect, '/session')
        : { ok: false, data: null };
      if (session.ok && session.data && session.data.authenticated) {
        state.user = session.data.user || {};
      }

      var lotRes = await loadLot(root, apiDirect, idcatalogue, lotNumber);
      if (!lotRes.ok || !lotRes.data || !lotRes.data.lot) {
        throw new Error((lotRes.data && (lotRes.data.error || lotRes.data.message)) || 'Lot not found');
      }
      state.lot = lotRes.data.lot;
      if (lotRes.data.user) {
        state.user = Object.assign({}, state.user || {}, lotRes.data.user);
      }

      fillLot(root, state.lot);
      paintActions(root, state.lot, state.user);
      applyConditionsLink(root, state.lot);
      bindQuickBids(root, function () { return state.lot; });
      bindBidHistoryMore(root);

      if (loading) loading.hidden = true;
      if (content) content.hidden = false;

      if (!root._scheduleTimer) {
        root._scheduleTimer = window.setInterval(function () {
          if (state.lot) updateScheduleUi(root, state.lot);
        }, 1000);
      }
    } catch (err) {
      console.error('[winwin lot]', err);
      if (loading) loading.hidden = true;
      if (error) {
        error.hidden = false;
        error.textContent = 'This lot could not be loaded yet. If it exists in the backoffice, confirm it is assigned to a catalogue on a published auction.';
      }
      return;
    }

    var poll = startLivePoll(root, apiDirect, idcatalogue, lotNumber, state);

    var form = root.querySelector('[data-lot-bid-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var msg = root.querySelector('[data-lot-bid-msg]');
        var btn = form.querySelector('[type="submit"]');
        var fd = new FormData(form);
        var body = {
          idcatalogue: idcatalogue,
          lot_number: lotNumber,
          idlot: String(fd.get('idlot') || ''),
          amount: Number(fd.get('amount') || 0),
          type: Number(fd.get('type') || 0),
          force_bid: withinSaleWindow(state.lot) ? 1 : 0
        };
        if (btn) {
          btn.disabled = true;
          btn.dataset.label = btn.dataset.label || btn.textContent;
          btn.textContent = 'Placing…';
        }
        if (msg) {
          msg.hidden = true;
          msg.classList.remove('is-error');
        }
        var save = await window.WinwinApi.request(apiDirect, '/bid', { method: 'POST', body: body });
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.label || 'Place bid';
        }
        if (msg) {
          msg.hidden = false;
          var errs = (save.data && save.data.errors) || [];
          var errText = errs.map(function (e) {
            return typeof e === 'string' ? e : (e && e.text) || '';
          }).filter(Boolean).join(' ');
          errText = sanitizeBidderError(errText || (save.data && save.data.error) || '');
          if (save.ok) {
            msg.classList.remove('is-error');
            msg.textContent = (save.data && save.data.message) || 'Your bid has been placed.';
            if (save.data && save.data.lot) {
              state.lot = mergeLotActivity(state.lot, save.data.lot);
              fillLot(root, state.lot);
              paintActions(root, state.lot, state.user);
              applyConditionsLink(root, state.lot);
            } else {
              var refreshed = await loadLot(root, apiDirect, idcatalogue, lotNumber);
              if (refreshed.ok && refreshed.data && refreshed.data.lot) {
                state.lot = mergeLotActivity(state.lot, refreshed.data.lot);
                fillLot(root, state.lot);
                paintActions(root, state.lot, state.user);
                applyConditionsLink(root, state.lot);
              }
            }
            form.reset();
            var typeInput = form.querySelector('[name="type"]');
            var idlotInput = form.querySelector('[name="idlot"]');
            if (typeInput) typeInput.value = String(bidTypeFor(state.lot));
            if (idlotInput && state.lot.idlot != null) idlotInput.value = String(state.lot.idlot);
            syncBidInput(root, state.lot);
            if (poll) poll.start();
            if (window.WinwinPush) {
              window.WinwinPush.notifyBidPlaced(state.lot, body.amount);
              window.WinwinPush.maybePromptAfterBid().catch(function () {});
            }
          } else {
            msg.classList.add('is-error');
            var code = save.data && save.data.code;
            if (code === 'identification_incomplete') {
              msg.innerHTML = 'Please complete your identification details in <a href="/pages/account-profile">Account → Profile</a> before placing a bid.';
            } else if (code === 'email_unconfirmed') {
              msg.textContent = errText || 'Please confirm your email before placing a bid.';
            } else {
              msg.textContent = errText || 'Could not place your bid.';
            }
          }
        }
      });
    }

    var watchBtn = root.querySelector('[data-lot-watch]');
    if (watchBtn && !watchBtn.dataset.bound) {
      watchBtn.dataset.bound = '1';
      watchBtn.addEventListener('click', async function () {
        if (!state.user) {
          window.location.href = loginUrl + '?next=' + encodeURIComponent(window.location.pathname + window.location.search);
          return;
        }
        var catlot = state.lot && (state.lot.idcatlot || state.lot.catlot);
        if (!catlot) {
          watchBtn.textContent = 'Watchlist unavailable';
          return;
        }
        var on = watchBtn.classList.contains('is-on');
        watchBtn.disabled = true;
        var path = '/account/bookmarks/' + encodeURIComponent(String(catlot));
        var res = await window.WinwinApi.request(apiDirect, path, {
          method: on ? 'DELETE' : 'POST',
          body: {}
        });
        watchBtn.disabled = false;
        if (res.ok) {
          state.lot.is_bookmarked = on ? 0 : 1;
          if (res.data && res.data.watch_count != null) {
            state.lot.watch_count = res.data.watch_count;
          } else {
            var prevWatch = Number(state.lot.watch_count) || 0;
            state.lot.watch_count = Math.max(0, prevWatch + (on ? -1 : 1));
          }
          paintActions(root, state.lot, state.user);
          renderActivity(root, state.lot);
        } else {
          watchBtn.textContent = on ? 'Could not remove' : 'Could not save';
          window.setTimeout(function () {
            paintActions(root, state.lot, state.user);
          }, 1600);
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lot-detail][data-selloff="true"]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
